import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const ClientMediaPlayerSXStyles: SxStyles = {
  ClientMediaPlayerSx: {
    height: '100%',
    '& .player': {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      height: '40%',
      aspectRatio: '16 / 9',
      maxWidth: '90%',
      pointerEvents: 'none',
      borderRadius: getResponsiveSize(12),
      overflow: 'hidden',
    },
    '& .image': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      zIndex: 1,
      height: 'auto',
      '&::before': {
        content: '""',
        paddingTop: '42.25%',
      },
      '& img': {
        position: 'absolute',
        inset: 0,
        margin: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
        width: 'auto',
        height: 'auto',
        borderRadius: getResponsiveSize(12),
      },
    },
  },
};
